// Decision table for the session-timer worker messages App.vue consumes.
//
// The worker's guard interval posts `timer_elapsed` when the 10-minute
// inactivity timer overshot (the tab resumed from a suspend) and
// `countdown_elapsed` when the 5-minute countdown itself overshot. A resumed
// tab has a present user, so the overshoot of the inactivity timer opens the
// countdown dialog instead of logging out on the spot (DCTL-2654).
export const TIMER_ACTIONS = Object.freeze({
	START_COUNTDOWN: "start_countdown",
	LOGOUT: "logout",
	TICK: "tick",
	IGNORE: "ignore",
});

export function sessionTimerAction(message) {
	switch (message) {
		case "timed_out":
		case "timer_elapsed":
			return TIMER_ACTIONS.START_COUNTDOWN;
		case "countdown_tick":
			return TIMER_ACTIONS.TICK;
		case "countdown_elapsed":
			return TIMER_ACTIONS.LOGOUT;
		default:
			return TIMER_ACTIONS.IGNORE;
	}
}
